declare global {
    interface Window {
        Stream?: (element: HTMLIFrameElement) => CloudflareStreamPlayer;
    }
}

export interface CloudflareStreamPlayer {
    play(): Promise<void>;
    pause(): void;
    addEventListener(event: string, callback: (e?: any) => void): void;
    removeEventListener?(event: string, callback: (e?: any) => void): void;
    currentTime: number;
    duration: number;
    ended: boolean;
    paused: boolean;
    muted: boolean;
    volume: number;
    controls: boolean;
    autoplay: boolean;
    loop: boolean;
    preload: boolean;
}

export function loadCloudflareAPI(onReady: () => void) {
    if (window.Stream) {
        onReady();
        return;
    }

    const existingScript = document.querySelector(
        'script[src="https://embed.cloudflarestream.com/embed/sdk.latest.js"]',
    );
    if (existingScript) {
        existingScript.addEventListener('load', onReady);
        return;
    }

    const script = document.createElement('script');
    script.src = 'https://embed.cloudflarestream.com/embed/sdk.latest.js';
    script.async = true;
    script.onload = onReady;
    document.head.appendChild(script);
}

export function extractCloudflareVideoId(url: string): string | null {
    try {
        if (url.includes('cloudflarestream.com')) {
            const match = url.match(/cloudflarestream\.com\/([a-f0-9]+)\//);
            return match ? match[1] : null;
        }
    } catch (e) {
        console.warn('Failed to parse Cloudflare Stream URL:', e);
    }
    return null;
}
